import { FieldBase } from './field-base.model';

export class FieldInput extends FieldBase {
  constructor(obj: {} = {}) {
    super(obj);
  }
}
